export default "__VITE_ASSET__RBMv_LkG__"